export default __webpack_public_path__ + "locales/pt-BR/DeleteProfileEverDialog.json?hash=a83f6f7ec77531c1b4f899b8112a82f7";